<template>
  <div :class="['plate',mode]">
    <div class="title1">股东持股明细</div>

    <div class="tab">
      <h1 v-for="(item,i) in tab" :class="[active == i ? 'active':'']"
        @click="chose(i)"
      >
        {{ item.name  }}
      </h1>
    </div>

    <!-- 滑动 -->

    <div class="swiper2 tab2">
    
      <div class="swiper-container">
          <div class="swiper-wrapper">
              <div
                  class="swiper-slide color63"
                  v-for="(item,i) in tab2"
              >
                <h1 :class="[active2 == i ? 'active':'']"
                  @click="chose2(i)"
                >
                  {{ item }}
                </h1>
              </div>
          </div>
      </div>
    </div>





    <div class="table">
      <!-- 表头 -->
      <div class="table_h color63">
        <span class="l">股东名称</span>
        <span class="r">持股数</span>
        <span class="r">占比</span>
        <span class="r">环比增减</span>
      </div>

      <!-- 表格数据 -->
      <div class="table_h" v-for="item in info_list" :key="item.HOLDER_NAME">
        <span class="l">{{item.HOLDER_NAME}}</span>
        <span class="r">{{numFn(item.HOLD_NUM) }}</span>
        <span class="r">{{parseFloat(item.FREE_HOLDNUM_RATIO).toFixed(2)}}%</span>
        <span :class="[
          'r',
          item.NEW_CHANGE_RATIO<0 ?'green':'',
          item.NEW_CHANGE_RATIO.includes('新进')?'red':'',
          item.NEW_CHANGE_RATIO > 0 ?'red':'',
          ]">{{ numFn2(item.NEW_CHANGE_RATIO)}}</span>
      </div>
    </div>




    <div class="company_link" @click="goDetail(link2)">
      <span class="color63">查看更多股本信息</span>
      <svg v-if="mode == 'light_mode'" xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
        <rect opacity="0.01" width="8" height="12" fill="#D8D8D8"/>
        <path d="M1.36 1.15428L6.64 5.96107L1.36 10.96" stroke="#636363" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>

      <svg v-else xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
        <rect opacity="0.01" width="8" height="12" fill="#D8D8D8"/>
        <path d="M1.35999 1.15428L6.63999 5.96107L1.35999 10.96" stroke="#B7B7B7" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>

  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
export default {
  props:{
    link2:String,
  },
  data(){
        return{
            mode:this.$route.params.mode,//light,dark
            code:this.$route.params.code,//sz000070

            
            tab:[
                {
                    name:'十大流通股东',
                },
                {
                    name:'十大股东',
                },
            ],
            active:0,


            
            active2:0,
            list:[],
            list1:[],
            list2:[],

            swiper2:null,

        }
    },
    created() {
        this.code = this.$route.params.code;
        this.getTen('stock_shareholders');
        this.getTen('stock_circulating_shareholders');

        //测试数据，因为接口本地调试请求会报错
        this.getTest();
    },
    computed:{
      tab2(){
        if(this.list.length > 0){
          return this.list.map(item=>{
            return item.report_date;
          })
        }
      },
      info_list(){
        if(this.list.length > 0){
          return this.list[this.active2].data;
        }
      }
    },
    watch:{
        tab2:{
            handler(val, oldVal){
                if(val.length > 0){
                    //这里只会调用一次
                    this.scrollSwiper();
                }
            },
            //deep:true //true 深度监听
        }
    },
    methods:{
        scrollSwiper(){
          console.log('scrollSwiper')
          if(this.swiper2){
              //清楚 已有滚动
              //this.swiper2.init();
              console.log('destroy')
              this.swiper2.destroy(true);
          }
          this.$nextTick(() => {
              this.swiper2 = new Swiper(".swiper-container", {
                  autoplay: false,
                  freeMode: true,//滚动自由模式
                  slidesPerView: "auto",
                  initialSlide:0,
              });
          });
        },
        // 跳转详情页
        goDetail(link) {
          //this.$goAppLink('link',`&jump_link=${link}`);
          this.$srH5CallNativeMethodApp('link',{
            jump_link: link,
          })
        },
        getTest(){
          let res =[
            {
              "data": [
                {
                  "EndDate": "2023-09-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 54.068839795771,
                  "FREE_RATIO_QOQ": "不变",
                  "HOLDER_NAME": "中国贵州茅台酒厂(集团)有限责任公司",
                  "HOLD_NUM": 679211576,
                  "NEW_CHANGE_RATIO": "不变"
                },
                {
                  "EndDate": "2023-09-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 6.924312795326,
                  "FREE_RATIO_QOQ": "-1.05993966",
                  "HOLDER_NAME": "香港中央结算有限公司",
                  "HOLD_NUM": 86983065,
                  "NEW_CHANGE_RATIO": "-1.05993966"
                },
                {
                  "EndDate": "2023-09-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 4.537245408327,
                  "FREE_RATIO_QOQ": "不变",
                  "HOLDER_NAME": "贵州省国有资本运营有限责任公司",
                  "HOLD_NUM": 56996777,
                  "NEW_CHANGE_RATIO": "不变"
                },
                {
                  "EndDate": "2023-09-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 2.21698270766,
                  "FREE_RATIO_QOQ": "不变",
                  "HOLDER_NAME": "贵州茅台酒厂(集团)技术开发有限公司",
                  "HOLD_NUM": 27849688,
                  "NEW_CHANGE_RATIO": "不变"
                },
                {
                  "EndDate": "2023-09-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 0.82766456047,
                  "FREE_RATIO_QOQ": "不变",
                  "HOLDER_NAME": "中央汇金资产管理有限责任公司",
                  "HOLD_NUM": 10397104,
                  "NEW_CHANGE_RATIO": "不变"
                },
                {
                  "EndDate": "2023-09-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 0.719374448833,
                  "FREE_RATIO_QOQ": "1.50971101",
                  "HOLDER_NAME": "深圳市金汇荣盛财富管理有限公司-金汇荣盛三号私募证券投资基金",
                  "HOLD_NUM": 9036766,
                  "NEW_CHANGE_RATIO": "1.50971101"
                },
                {
                  "EndDate": "2023-09-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 0.711119697869,
                  "FREE_RATIO_QOQ": "1.59100757",
                  "HOLDER_NAME": "珠海市瑞丰汇邦资产管理有限公司-瑞丰汇邦三号私募证券投资基金",
                  "HOLD_NUM": 8933070,
                  "NEW_CHANGE_RATIO": "1.59100757"
                },
                {
                  "EndDate": "2023-09-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 0.639982572808,
                  "FREE_RATIO_QOQ": "不变",
                  "HOLDER_NAME": "中国证券金融股份有限公司",
                  "HOLD_NUM": 8039447,
                  "NEW_CHANGE_RATIO": "不变"
                },
                {
                  "EndDate": "2023-09-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 0.477246258511,
                  "FREE_RATIO_QOQ": "10.79452285",
                  "HOLDER_NAME": "中国工商银行-上证50交易型开放式指数证券投资基金",
                  "HOLD_NUM": 5995157,
                  "NEW_CHANGE_RATIO": "10.79452285"
                },
                {
                  "EndDate": "2023-09-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 0.351992815144,
                  "FREE_RATIO_QOQ": "新进",
                  "HOLDER_NAME": "中国人寿保险股份有限公司-传统-普通保险产品-005L-CT001沪",
                  "HOLD_NUM": 4421726,
                  "NEW_CHANGE_RATIO": "新进"
                }
              ],
              "report_date": "2023-09-30"
            },
            {
              "data": [
                {
                  "EndDate": "2023-06-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 54.068839795771,
                  "FREE_RATIO_QOQ": "0.01653764",
                  "HOLDER_NAME": "中国贵州茅台酒厂(集团)有限责任公司",
                  "HOLD_NUM": 679211576,
                  "NEW_CHANGE_RATIO": "0.01653764"
                },
                {
                  "EndDate": "2023-06-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 6.99849259408,
                  "FREE_RATIO_QOQ": "-3.6044812",
                  "HOLDER_NAME": "香港中央结算有限公司",
                  "HOLD_NUM": 87914910,
                  "NEW_CHANGE_RATIO": "-3.6044812"
                },
                {
                  "EndDate": "2023-06-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 4.537245408327,
                  "FREE_RATIO_QOQ": "不变",
                  "HOLDER_NAME": "贵州省国有资本运营有限责任公司",
                  "HOLD_NUM": 56996777,
                  "NEW_CHANGE_RATIO": "不变"
                },
                {
                  "EndDate": "2023-06-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 2.21698270766,
                  "FREE_RATIO_QOQ": "0.0158016",
                  "HOLDER_NAME": "贵州茅台酒厂(集团)技术开发有限公司",
                  "HOLD_NUM": 27849688,
                  "NEW_CHANGE_RATIO": "0.0158016"
                },
                {
                  "EndDate": "2023-06-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 0.82766456047,
                  "FREE_RATIO_QOQ": "不变",
                  "HOLDER_NAME": "中央汇金资产管理有限责任公司",
                  "HOLD_NUM": 10397104,
                  "NEW_CHANGE_RATIO": "不变"
                },
                {
                  "EndDate": "2023-06-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 0.708675496805,
                  "FREE_RATIO_QOQ": "7.09511452",
                  "HOLDER_NAME": "深圳市金汇荣盛财富管理有限公司-金汇荣盛三号私募证券投资基金",
                  "HOLD_NUM": 8902366,
                  "NEW_CHANGE_RATIO": "7.09511452"
                },
                {
                  "EndDate": "2023-06-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 0.699982916703,
                  "FREE_RATIO_QOQ": "8.18545628",
                  "HOLDER_NAME": "珠海市瑞丰汇邦资产管理有限公司-瑞丰汇邦三号私募证券投资基金",
                  "HOLD_NUM": 8793170,
                  "NEW_CHANGE_RATIO": "8.18545628"
                },
                {
                  "EndDate": "2023-06-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 0.639982572808,
                  "FREE_RATIO_QOQ": "不变",
                  "HOLDER_NAME": "中国证券金融股份有限公司",
                  "HOLD_NUM": 8039447,
                  "NEW_CHANGE_RATIO": "不变"
                },
                {
                  "EndDate": "2023-06-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 0.43074896326,
                  "FREE_RATIO_QOQ": "9.3338708",
                  "HOLDER_NAME": "中国工商银行-上证50交易型开放式指数证券投资基金",
                  "HOLD_NUM": 5411059,
                  "NEW_CHANGE_RATIO": "9.3338708"
                },
                {
                  "EndDate": "2023-06-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 0.338456013854,
                  "FREE_RATIO_QOQ": "新进",
                  "HOLDER_NAME": "中国银行股份有限公司-招商中证白酒指数分级证券投资基金",
                  "HOLD_NUM": 4251677,
                  "NEW_CHANGE_RATIO": "新进"
                }
              ],
              "report_date": "2023-06-30"
            },
            {
              "data": [
                {
                  "EndDate": "2023-03-31 00:00:00",
                  "FREE_HOLDNUM_RATIO": 54.059899563588,
                  "FREE_RATIO_QOQ": "0.11902161",
                  "HOLDER_NAME": "中国贵州茅台酒厂(集团)有限责任公司",
                  "HOLD_NUM": 679099269,
                  "NEW_CHANGE_RATIO": "0.11902161"
                },
                {
                  "EndDate": "2023-03-31 00:00:00",
                  "FREE_HOLDNUM_RATIO": 7.260184582396,
                  "FREE_RATIO_QOQ": "7.55157966",
                  "HOLDER_NAME": "香港中央结算有限公司",
                  "HOLD_NUM": 91202279,
                  "NEW_CHANGE_RATIO": "7.55157966"
                },
                {
                  "EndDate": "2023-03-31 00:00:00",
                  "FREE_HOLDNUM_RATIO": 4.537245408327,
                  "FREE_RATIO_QOQ": "不变",
                  "HOLDER_NAME": "贵州省国有资本运营有限责任公司",
                  "HOLD_NUM": 56996777,
                  "NEW_CHANGE_RATIO": "不变"
                },
                {
                  "EndDate": "2023-03-31 00:00:00",
                  "FREE_HOLDNUM_RATIO": 2.216632444349,
                  "FREE_RATIO_QOQ": "0.11937255",
                  "HOLDER_NAME": "贵州茅台酒厂(集团)技术开发有限公司",
                  "HOLD_NUM": 27845288,
                  "NEW_CHANGE_RATIO": "0.11937255"
                },
                {
                  "EndDate": "2023-03-31 00:00:00",
                  "FREE_HOLDNUM_RATIO": 0.82766456047,
                  "FREE_RATIO_QOQ": "不变",
                  "HOLDER_NAME": "中央汇金资产管理有限责任公司",
                  "HOLD_NUM": 10397104,
                  "NEW_CHANGE_RATIO": "不变"
                },
                {
                  "EndDate": "2023-03-31 00:00:00",
                  "FREE_HOLDNUM_RATIO": 0.661725327015,
                  "FREE_RATIO_QOQ": "9.31449254",
                  "HOLDER_NAME": "深圳市金汇荣盛财富管理有限公司-金汇荣盛三号私募证券投资基金",
                  "HOLD_NUM": 8312579,
                  "NEW_CHANGE_RATIO": "9.31449254"
                },
                {
                  "EndDate": "2023-03-31 00:00:00",
                  "FREE_HOLDNUM_RATIO": 0.647021273242,
                  "FREE_RATIO_QOQ": "8.31859943",
                  "HOLDER_NAME": "珠海市瑞丰汇邦资产管理有限公司-瑞丰汇邦三号私募证券投资基金",
                  "HOLD_NUM": 8127867,
                  "NEW_CHANGE_RATIO": "8.31859943"
                },
                {
                  "EndDate": "2023-03-31 00:00:00",
                  "FREE_HOLDNUM_RATIO": 0.639982572808,
                  "FREE_RATIO_QOQ": "不变",
                  "HOLDER_NAME": "中国证券金融股份有限公司",
                  "HOLD_NUM": 8039447,
                  "NEW_CHANGE_RATIO": "不变"
                },
                {
                  "EndDate": "2023-03-31 00:00:00",
                  "FREE_HOLDNUM_RATIO": 0.393975773561,
                  "FREE_RATIO_QOQ": "-7.99464972",
                  "HOLDER_NAME": "中国工商银行-上证50交易型开放式指数证券投资基金",
                  "HOLD_NUM": 4949115,
                  "NEW_CHANGE_RATIO": "-7.99464972"
                },
                {
                  "EndDate": "2023-03-31 00:00:00",
                  "FREE_HOLDNUM_RATIO": 0.323925658841,
                  "FREE_RATIO_QOQ": "新进",
                  "HOLDER_NAME": "中国人寿保险股份有限公司-传统-普通保险产品-005L-CT001沪",
                  "HOLD_NUM": 4069147,
                  "NEW_CHANGE_RATIO": "新进"
                }
              ],
              "report_date": "2023-03-31"
            },
            {
              "data": [
                {
                  "EndDate": "2022-12-31 00:00:00",
                  "FREE_HOLDNUM_RATIO": 53.995633092177,
                  "FREE_RATIO_QOQ": "不变",
                  "HOLDER_NAME": "中国贵州茅台酒厂(集团)有限责任公司",
                  "HOLD_NUM": 678291955,
                  "NEW_CHANGE_RATIO": "不变"
                },
                {
                  "EndDate": "2022-12-31 00:00:00",
                  "FREE_HOLDNUM_RATIO": 6.750421151828,
                  "FREE_RATIO_QOQ": "-7.65731927",
                  "HOLDER_NAME": "香港中央结算有限公司",
                  "HOLD_NUM": 84798642,
                  "NEW_CHANGE_RATIO": "-7.65731927"
                },
                {
                  "EndDate": "2022-12-31 00:00:00",
                  "FREE_HOLDNUM_RATIO": 4.537245408327,
                  "FREE_RATIO_QOQ": "不变",
                  "HOLDER_NAME": "贵州省国有资本运营有限责任公司",
                  "HOLD_NUM": 56996777,
                  "NEW_CHANGE_RATIO": "不变"
                },
                {
                  "EndDate": "2022-12-31 00:00:00",
                  "FREE_HOLDNUM_RATIO": 2.213989548461,
                  "FREE_RATIO_QOQ": "不变",
                  "HOLDER_NAME": "贵州茅台酒厂(集团)技术开发有限公司",
                  "HOLD_NUM": 27812088,
                  "NEW_CHANGE_RATIO": "不变"
                },
                {
                  "EndDate": "2022-12-31 00:00:00",
                  "FREE_HOLDNUM_RATIO": 0.82766456047,
                  "FREE_RATIO_QOQ": "不变",
                  "HOLDER_NAME": "中央汇金资产管理有限责任公司",
                  "HOLD_NUM": 10397104,
                  "NEW_CHANGE_RATIO": "不变"
                },
                {
                  "EndDate": "2022-12-31 00:00:00",
                  "FREE_HOLDNUM_RATIO": 0.639982572808,
                  "FREE_RATIO_QOQ": "不变",
                  "HOLDER_NAME": "中国证券金融股份有限公司",
                  "HOLD_NUM": 8039447,
                  "NEW_CHANGE_RATIO": "不变"
                },
                {
                  "EndDate": "2022-12-31 00:00:00",
                  "FREE_HOLDNUM_RATIO": 0.605340894563,
                  "FREE_RATIO_QOQ": "1.55858122",
                  "HOLDER_NAME": "深圳市金汇荣盛财富管理有限公司-金汇荣盛三号私募证券投资基金",
                  "HOLD_NUM": 7604279,
                  "NEW_CHANGE_RATIO": "1.55858122"
                },
                {
                  "EndDate": "2022-12-31 00:00:00",
                  "FREE_HOLDNUM_RATIO": 0.597331646338,
                  "FREE_RATIO_QOQ": "17.06157722",
                  "HOLDER_NAME": "珠海市瑞丰汇邦资产管理有限公司-瑞丰汇邦三号私募证券投资基金",
                  "HOLD_NUM": 7503667,
                  "NEW_CHANGE_RATIO": "17.06157722"
                },
                {
                  "EndDate": "2022-12-31 00:00:00",
                  "FREE_HOLDNUM_RATIO": 0.433514769728,
                  "FREE_RATIO_QOQ": "-3.08175917",
                  "HOLDER_NAME": "中国银行股份有限公司-招商中证白酒指数分级证券投资基金",
                  "HOLD_NUM": 5445803,
                  "NEW_CHANGE_RATIO": "-3.08175917"
                },
                {
                  "EndDate": "2022-12-31 00:00:00",
                  "FREE_HOLDNUM_RATIO": 0.428209633865,
                  "FREE_RATIO_QOQ": "-7.41507621",
                  "HOLDER_NAME": "中国工商银行-上证50交易型开放式指数证券投资基金",
                  "HOLD_NUM": 5379160,
                  "NEW_CHANGE_RATIO": "-7.41507621"
                }
              ],
              "report_date": "2022-12-31"
            },
            {
              "data": [
                {
                  "EndDate": "2022-09-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 53.995633092177,
                  "FREE_RATIO_QOQ": "不变",
                  "HOLDER_NAME": "中国贵州茅台酒厂(集团)有限责任公司",
                  "HOLD_NUM": 678291955,
                  "NEW_CHANGE_RATIO": "不变"
                },
                {
                  "EndDate": "2022-09-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 7.31018538641,
                  "FREE_RATIO_QOQ": "1.2126978",
                  "HOLDER_NAME": "香港中央结算有限公司",
                  "HOLD_NUM": 91830388,
                  "NEW_CHANGE_RATIO": "1.2126978"
                },
                {
                  "EndDate": "2022-09-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 4.537245408327,
                  "FREE_RATIO_QOQ": "不变",
                  "HOLDER_NAME": "贵州省国有资本运营有限责任公司",
                  "HOLD_NUM": 56996777,
                  "NEW_CHANGE_RATIO": "不变"
                },
                {
                  "EndDate": "2022-09-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 2.213989548461,
                  "FREE_RATIO_QOQ": "不变",
                  "HOLDER_NAME": "贵州茅台酒厂(集团)技术开发有限公司",
                  "HOLD_NUM": 27812088,
                  "NEW_CHANGE_RATIO": "不变"
                },
                {
                  "EndDate": "2022-09-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 0.82766456047,
                  "FREE_RATIO_QOQ": "不变",
                  "HOLDER_NAME": "中央汇金资产管理有限责任公司",
                  "HOLD_NUM": 10397104,
                  "NEW_CHANGE_RATIO": "不变"
                },
                {
                  "EndDate": "2022-09-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 0.639982572808,
                  "FREE_RATIO_QOQ": "不变",
                  "HOLDER_NAME": "中国证券金融股份有限公司",
                  "HOLD_NUM": 8039447,
                  "NEW_CHANGE_RATIO": "不变"
                },
                {
                  "EndDate": "2022-09-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 0.596050956306,
                  "FREE_RATIO_QOQ": "16.96980859",
                  "HOLDER_NAME": "深圳市金汇荣盛财富管理有限公司-金汇荣盛三号私募证券投资基金",
                  "HOLD_NUM": 7487579,
                  "NEW_CHANGE_RATIO": "16.96980859"
                },
                {
                  "EndDate": "2022-09-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 0.510271312368,
                  "FREE_RATIO_QOQ": "1.79935036",
                  "HOLDER_NAME": "珠海市瑞丰汇邦资产管理有限公司-瑞丰汇邦三号私募证券投资基金",
                  "HOLD_NUM": 6410017,
                  "NEW_CHANGE_RATIO": "1.79935036"
                },
                {
                  "EndDate": "2022-09-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 0.462504710643,
                  "FREE_RATIO_QOQ": "35.67604805",
                  "HOLDER_NAME": "中国工商银行-上证50交易型开放式指数证券投资基金",
                  "HOLD_NUM": 5809974,
                  "NEW_CHANGE_RATIO": "35.67604805"
                },
                {
                  "EndDate": "2022-09-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 0.447299461916,
                  "FREE_RATIO_QOQ": "6.30710092",
                  "HOLDER_NAME": "中国银行股份有限公司-招商中证白酒指数分级证券投资基金",
                  "HOLD_NUM": 5618966,
                  "NEW_CHANGE_RATIO": "6.30710092"
                }
              ],
              "report_date": "2022-09-30"
            },
            {
              "data": [
                {
                  "EndDate": "2022-06-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 53.995633092177,
                  "FREE_RATIO_QOQ": "不变",
                  "HOLDER_NAME": "中国贵州茅台酒厂(集团)有限责任公司",
                  "HOLD_NUM": 678291955,
                  "NEW_CHANGE_RATIO": "不变"
                },
                {
                  "EndDate": "2022-06-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 7.222597110105,
                  "FREE_RATIO_QOQ": "10.56638831",
                  "HOLDER_NAME": "香港中央结算有限公司",
                  "HOLD_NUM": 90730106,
                  "NEW_CHANGE_RATIO": "10.56638831"
                },
                {
                  "EndDate": "2022-06-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 4.537245408327,
                  "FREE_RATIO_QOQ": "不变",
                  "HOLDER_NAME": "贵州省国有资本运营有限责任公司",
                  "HOLD_NUM": 56996777,
                  "NEW_CHANGE_RATIO": "不变"
                },
                {
                  "EndDate": "2022-06-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 2.213989548461,
                  "FREE_RATIO_QOQ": "不变",
                  "HOLDER_NAME": "贵州茅台酒厂(集团)技术开发有限公司",
                  "HOLD_NUM": 27812088,
                  "NEW_CHANGE_RATIO": "不变"
                },
                {
                  "EndDate": "2022-06-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 0.82766456047,
                  "FREE_RATIO_QOQ": "不变",
                  "HOLDER_NAME": "中央汇金资产管理有限责任公司",
                  "HOLD_NUM": 10397104,
                  "NEW_CHANGE_RATIO": "不变"
                },
                {
                  "EndDate": "2022-06-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 0.639982572808,
                  "FREE_RATIO_QOQ": "不变",
                  "HOLDER_NAME": "中国证券金融股份有限公司",
                  "HOLD_NUM": 8039447,
                  "NEW_CHANGE_RATIO": "不变"
                },
                {
                  "EndDate": "2022-06-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 0.509576756145,
                  "FREE_RATIO_QOQ": "7.9594222",
                  "HOLDER_NAME": "深圳市金汇荣盛财富管理有限公司-金汇荣盛三号私募证券投资基金",
                  "HOLD_NUM": 6401292,
                  "NEW_CHANGE_RATIO": "7.9594222"
                },
                {
                  "EndDate": "2022-06-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 0.501252032124,
                  "FREE_RATIO_QOQ": "10.90812952",
                  "HOLDER_NAME": "珠海市瑞丰汇邦资产管理有限公司-瑞丰汇邦三号私募证券投资基金",
                  "HOLD_NUM": 6296717,
                  "NEW_CHANGE_RATIO": "10.90812952"
                },
                {
                  "EndDate": "2022-06-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 0.42076160299,
                  "FREE_RATIO_QOQ": "-21.37036616",
                  "HOLDER_NAME": "中国银行股份有限公司-招商中证白酒指数分级证券投资基金",
                  "HOLD_NUM": 5285598,
                  "NEW_CHANGE_RATIO": "-21.37036616"
                },
                {
                  "EndDate": "2022-06-30 00:00:00",
                  "FREE_HOLDNUM_RATIO": 0.340888990571,
                  "FREE_RATIO_QOQ": "-4.68283332",
                  "HOLDER_NAME": "中国工商银行-上证50交易型开放式指数证券投资基金",
                  "HOLD_NUM": 4282240,
                  "NEW_CHANGE_RATIO": "-4.68283332"
                }
              ],
              "report_date": "2022-06-30"
            }
          ];
          this.list1 = res;
          this.list = res;
          this.list2 = res;
        },
        getTen(kind){
            let _this = this;
            //kind stock_shareholders  stock_circulating_shareholders
            //十大股东
            // https://igp-img-upload-1251605428.cos.ap-shanghai.myqcloud.com/stock_shareholders/sz300748.json
            //十大流通股东
            //https://igp-img-upload-1251605428.cos.ap-shanghai.myqcloud.com/stock_circulating_shareholders/sz300748.json
            $.ajax({
                xhrFields: { withCredentials: true },
                type: "get",
                url: `https://igp-img-upload-1251605428.cos.ap-shanghai.myqcloud.com/${kind}/${this.code}.json`,
                cache: false,
                async: true,
                error: function () {
                    return false;
                },
                success: function (res) {
                    console.log(kind,res);
                    if(kind == 'stock_circulating_shareholders'){
                      _this.list1 = res;
                      _this.list = res;

                      console.log('tab',_this.tab2);
                      _this.$emit('done');
                    }
                    else{
                      _this.list2 = res;
                    }
                    
                },
            })
        },
        numFn(num){
          let abs_amount = Math.abs(num);
          let _str = num;
          if (abs_amount > 99999999) {
            _str = (num / 100000000).toFixed(2) + "亿";
          } else if (num > 9999) {
            _str = parseInt(num / 10000) + "万";
          } else if(num == ""){
            _str = "0";
          } 
          else{
            _str = parseInt(num);
          }
          return _str;
        },
        numFn2(num){
          if(isNaN(num)){
            return num;
          }
          else{
            //数字
            return parseFloat(num).toFixed(2)+'%';
          }
        },
        chose2(i){
          this.active2 = i;
        },
        chose(i){
          this.active = i;
          //
          if(i == 0){
            this.list = this.list1;
          }
          else{
            this.list = this.list2;
          }
          this.chose2(0);
          this.scrollSwiper();
        }
        
    }
}

</script>
<style lang="scss" scoped>
  @import "~@/assets/sass/globalapp.scss";

  *{
        touch-action:unset!important;
    }
  .plate{
    padding: rem2(15px) rem2(12px);
    .tab{
      display: flex;
      border-radius:rem2(6px);
      border: rem2(1px) solid #DCDCDC;
      font-size: rem2(13px);
      width: rem2(200px);
      margin: rem2(10px) auto;
      overflow: hidden;
      >h1{
        display: flex;
        width: 50%;
        padding: rem2(6px) rem2(8px);
        justify-content: center;
        align-items: center;
        box-sizing: border-box;

        &.active{
          background: #FE484A;
          color: #F3F3F3;
        }
        
      }
    }

  .swiper2{
    width: 100%;
  }

    .tab2.swiper2{
      .swiper-container{
          height: 100%;
      }
      .swiper-slide{
        //width: rem2(70px);
        width: auto!important;
      }
    }
    .tab2{
      border-bottom: rem2(.5px) solid #EBEBEB;
      margin-bottom: rem2(10px);

      h1{
        height: rem2(38px);
        width: max-content;
        line-height: rem2(38px);
        flex-shrink: 0;
        margin-right: rem2(10px);
        &.active{
          border-bottom: rem2(1.5px) solid #FE484A;
          color: #FE484A;
        }
      }
    }


    .table{
      .table_h{
        display: flex;
        justify-content: space-between;
        line-height: 1.3;
        padding: rem2(5px);
        .l{
          width: rem2(147px);
        }
        .r{
          width: rem2(60px);
          text-align: right;
        }
      }
    }

    .company_link{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      margin: rem2(10px) 0 0;
      >span{
        font-size: rem2(13px);
      }
      >svg{
        width: rem2(8px);
        height: rem2(12px);
        margin-left: rem2(5px);
      }
    }


  }

  .light_mode{

  }

  .dark_mode{
    .plate{
      .tab{

        border-color:rgba(220, 220, 220, 0.35) ;
        >h1{


          &.active{
            background: #FF443D;
          }
          
        }
      }

      .tab2{
        border-bottom-color: #222;
        h1{


          &.active{
            color: #FF443D;
            border-color: #FF443D;
          }
          
        }
      }
    }


  }
</style>